import EditorMarker from './EditorMarker';

export default class EditorTileSprite extends EditorMarker {
  constructor(scene: Phaser.Scene, x?: number, y?: number, width?: number, height?: number, texture?: string, frame?: number | string) {
    super(scene, x, y);
  }
}
